import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ImageReviewerModelService} from '../../../Models/Tasks/General/image-reviewer-model.service';
import {ImageReviewerFilters} from '../../../../Models/Tasks/General/image-reviewer-filters.model';
import {ImageReviewerDto} from '../../../../Models/Tasks/General/image-reviewer.interface';

@Injectable({
  providedIn: 'root'
})
export class ImageReviewerApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ImageReviewerModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las imagenes que están por revisar
   *
   */
  public getImagesForReview(filters: ImageReviewerFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getCamposImagenesValoracion', filters).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar la valoración de la imagen
   *
   */
  saveAssessImage(image: ImageReviewerDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setCamposImagenesValoracion', image).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
